<template>
  <nav app>

  <v-app-bar
      absolute
      color="primary"
      dark
      shrink-on-scroll
      prominent
      scroll-target="#scrolling-techniques"
      app
    >
    <v-row>
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-row>
      <v-toolbar-title>
        <v-card flat class="primary mt-6 mr-6" width="100%">
          <v-card-title>
            <v-row justify="center">
            <strong class="display-1">Juba Restaurant</strong>
            </v-row>
          </v-card-title>
        </v-card>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="goHome">
        <v-icon>mdi-view-dashboard</v-icon>
      </v-btn>
    </v-app-bar>
   
      <v-navigation-drawer 
        v-model ="drawer"
  
        color="primary"
        dark
        app 
        floating
        persistent
        mobile-break-point="991"
        width="100%"
        >

          <v-row justify="center">
            <v-spacer></v-spacer>
            <v-card flat class="primary" elevation="8" width="100%"> 
              <v-btn class="mt-4 ml-4" text icon @click="drawer = !drawer" >
                <v-icon size="40px">mdi-close</v-icon>
              </v-btn>
            </v-card>
          </v-row>

          <v-row justify="center">
            <v-card flat class="primary" elevation="2" width="100%">
              <v-card-title>
                <v-row justify="center">
                <strong class="display-1">Juba Restaurant</strong>
                </v-row>
              </v-card-title>
            </v-card>
          </v-row>
          <v-row>
            <v-card>  </v-card>
          </v-row>
<!-- 
          <v-divider class="mt-10"></v-divider>     -->
         <v-list
            
            v-for="subpages in juba.menu"
            :key="subpages.id"
         >
          <v-card flat class="primary" elevation="2" width="100%">
            <nestedList :subpages="subpages" ></nestedList>
          </v-card>
         </v-list>
 
      </v-navigation-drawer>
  </nav>
</template>

<script>
import nestedList from "@/components/nestedList";
export default {
    name:  "MobileHeader2",
    props: {
        juba: Object
    },
    data () {
        return {
            drawer: false,
            hideOnScroll : false
        }
    },
    methods: {
      goHome() {
        this.$router.push('/')
      }
    },
    components: {
        nestedList
    }

}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }
  }
  .title {
 
    font-size: 400px;
    
  }
  .drawer-title{
    width: 100%;
    height: 50px;
    border-style: hidden;
    
    text-align: center;
    font-style: normal;
    font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; 
    font-weight: 800;
    // color: rgb(109, 8, 16);
    font-size: 32px;
    
    margin-top: 6px;
    // border-radius: 10px;
    background: rgba(143, 1, 43, 0.4), 0 1px 15px 0 rgba(138, 3, 3, 0.19);;
    box-shadow: 0 3px 12px 0 rgba(143, 1, 43, 0.4), 0 1px 15px 0 rgba(138, 3, 3, 0.19);
    
  }
  .top-box{
    width: 100%;
    height: 60px;
    
    border-style: hidden;
    // border-radius: 5px;
    // background:rgb(109, 8, 16);
    // box-shadow: 0 3px 12px 0 rgba(143, 1, 43, 0.4), 0 1px 15px 0 rgba(138, 3, 3, 0.19);
    background: rgba(143, 1, 43, 0.4), 0 1px 15px 0 rgba(138, 3, 3, 0.19);;
    box-shadow: 0 3px 12px 0 rgba(143, 1, 43, 0.4), 0 1px 15px 0 rgba(138, 3, 3, 0.19);
  }
  
</style>